/**@jsx jsx */
import { jsx } from 'theme-ui';

export const Question = ({ className }) => (
  <svg
    className={className}
    width="25"
    height="26"
    viewBox="0 0 25 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M12.5 20.0596C13.1742 20.0596 13.7207 19.513 13.7207 18.8389C13.7207 18.1647 13.1742 17.6182 12.5 17.6182C11.8258 17.6182 11.2793 18.1647 11.2793 18.8389C11.2793 19.513 11.8258 20.0596 12.5 20.0596Z"
        fill="#E4E4E4"
      />
      <path
        d="M12.5 0.357422C5.5916 0.357422 0 5.9481 0 12.8574C0 19.7658 5.59067 25.3574 12.5 25.3574C19.4084 25.3574 25 19.7667 25 12.8574C25 5.94902 19.4093 0.357422 12.5 0.357422ZM12.5 23.4043C6.67104 23.4043 1.95312 18.6872 1.95312 12.8574C1.95312 7.02847 6.67026 2.31055 12.5 2.31055C18.329 2.31055 23.0469 7.02769 23.0469 12.8574C23.0469 18.6864 18.3297 23.4043 12.5 23.4043Z"
        fill="#E4E4E4"
      />
      <path
        d="M12.5 6.63184C10.3461 6.63184 8.59375 8.38418 8.59375 10.5381C8.59375 11.0774 9.03096 11.5146 9.57031 11.5146C10.1097 11.5146 10.5469 11.0774 10.5469 10.5381C10.5469 9.46113 11.423 8.58496 12.5 8.58496C13.577 8.58496 14.4531 9.46113 14.4531 10.5381C14.4531 11.615 13.577 12.4912 12.5 12.4912C11.9606 12.4912 11.5234 12.9284 11.5234 13.4678V15.9092C11.5234 16.4485 11.9606 16.8857 12.5 16.8857C13.0394 16.8857 13.4766 16.4485 13.4766 15.9092V14.3208C15.1595 13.886 16.4062 12.3549 16.4062 10.5381C16.4062 8.38418 14.6539 6.63184 12.5 6.63184Z"
        fill="#E4E4E4"
      />
    </g>
    <defs>
      <clipPath>
        <rect y="0.357422" width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
